module.exports = __webpack_public_path__ + "assets/img/632224.2a9d3832.png";